import Mustache from 'mustache';

const campaignCarSearch = {
  _searchResultsList: null,
  _searchResultsTemplate: null,
  _loadMoreContainer: null,
  _loadMoreCount: null,
  _noCampaignCarsFound: null,
  _searchFilters: {},
  _language: typeof window.stage_language !== 'undefined' ? window.stage_language : window.location.href.split('/')[3],

  init: function() {
    const self = this;
    const campaignCarSearchForm = document.getElementById('campaign-cars-search-form');

    if (campaignCarSearchForm) {
      self._searchResultsList = document.getElementById('campaign-cars-search-results-list');
      self._searchResultsTemplate = document.getElementById('campaign-cars-search-results-template');
      self._loadMoreContainer = document.getElementById('load-more-campaign-cars-container');
      self._loadMoreCount = document.getElementById('load-more-campaign-cars-count');
      self._noCampaignCarsFound = document.getElementById('no-campaign-cars-found');
      self._searchForm = campaignCarSearchForm;
      self._vehicleCategoriesToTypes = JSON.parse(document.getElementById('campaign-cars-vehicle-categories').textContent);

      const hiddenInputs = Array.from(campaignCarSearchForm.querySelectorAll('input[type="hidden"]'));
      hiddenInputs.forEach(input => self._updateSearchFilters(input.name, input.value));

      // Listen to multiselects
      const multiselectKeys = Object.keys(window.multiselects);

      for (const key of multiselectKeys) {
        if (window.multiselects[key].selectDetails.form === campaignCarSearchForm) { // Check if multiselect actually belongs to campaign search form
          window.multiselects[key].addCallback({
            onValueChange: function(multiselectData, wasUnSelectAll) {
              self._updateSearchFilters(multiselectData.selectDetails.name, multiselectData.getValue());
              self._executeSearch(true);
              self._updateLinkHref();

              if (multiselectData.selectDetails.name === 'make') {
                self._updateModels(multiselectData, wasUnSelectAll);
              }
            }
          });
        }
      }

      // Listen to load more button
      const loadMoreButton = document.getElementById('load-more-campaign-cars');

      loadMoreButton.addEventListener('click', function() {
        self._executeSearch();
        self._updateLinkHref();
      });
    }
  },

  _updateSearchFilters: function(name, value) {
    if (value) {
      this._searchFilters[name] = value.includes(',') ? value.split(',') : value;
    }
    else if (name in this._searchFilters) {
      delete this._searchFilters[name];
    }
  },

  _removeSearchFilters: function(name, valuesToRemove) {
    if (name in this._searchFilters) {
      if (this._searchFilters[name].length === valuesToRemove.length) {
        delete this._searchFilters[name];
      }
      else {
        this._searchFilters[name] = this._searchFilters[name].filter(value => !valuesToRemove.includes(value));
      }
    }
  },

  _executeSearch: function(replace = false) {

    const spinner = document.getElementById('spinner');
    spinner.hidden = false;

    if(replace) {
      this._searchFilters['limit'] = 0;
    }

    const url = new URL(window.location.origin + '/stage-ajax/campaign-car-search');
    url.searchParams.append('stage-language', this._language);
    url.searchParams.append('limit', this._searchFilters.limit);

    Object.keys(this._searchFilters).forEach((filter) => {
      if (filter === 'category') {
        const types = [this._searchFilters[filter]].flat().map((category) => this._vehicleCategoriesToTypes[category]);
        url.searchParams.append('preset_type', types);
      } else {
        url.searchParams.append(filter, this._searchFilters[filter]);
      }
    });

    fetch(url)
      .then(response => response.json())
      .then(searchResults => {
        this._displaySearchResults(searchResults, replace);
      });
  },

  _displaySearchResults: function(searchResults, replace) {
    if (searchResults && searchResults.campaignCars) {

      if(replace) {
        this._searchResultsList.innerHTML = Mustache.render(this._searchResultsTemplate.innerHTML, {
          campaign_cars: searchResults.campaignCars,
          rest_count: searchResults.restCount
        });
      } else {
        this._searchResultsList.innerHTML += Mustache.render(this._searchResultsTemplate.innerHTML, {
          campaign_cars: searchResults.campaignCars,
          rest_count: searchResults.restCount
        });
      }

      // spinner.hidden = true; // spinner? no such thing...
      document.getElementById('campaign-car-limit').value = searchResults.limit;
      const form = document.getElementById('campaign-cars-search-form');
      const hiddenInputs = Array.from(form.querySelectorAll('input[type="hidden"]'));
      hiddenInputs.forEach(input => this._updateSearchFilters(input.name, input.value));

      if (searchResults.campaignCars.length) {
        this._noCampaignCarsFound.hidden = true;

        if (searchResults.restCount) {
          this._loadMoreCount.innerHTML = searchResults.restCount;
          this._loadMoreContainer.hidden = false;
        }
        else {
          this._loadMoreContainer.hidden = true;
        }
      }
      else {
        this._noCampaignCarsFound.hidden = false;
        this._loadMoreContainer.hidden = true;
      }

    }
  },

  _updateModels: function(makeSelect, wasUnSelectAll) {
    const modelSelect = window.multiselects['campaign-cars-search-model'];

    if (wasUnSelectAll) {
      this._clearSelect(modelSelect);
    }
    else {
      const changedMake = makeSelect.selectDetails.latestSelection.value;

      if (makeSelect.selectDetails.latestSelection.wasUnChecked) {
        this._removeModelsByMake(changedMake, modelSelect);
      }
      else {
        this._getModelsByMake(changedMake, modelSelect);
      }
    }
  },

  _clearSelect: function(select) {
    const allOptions = Array.from(select.element.options).map(option => option.value);
    this._updateSearchFilters(select.selectDetails.name, false);

    select.unSelectAll(false);
    select.removeOptions(allOptions, false);
    select.disableMultiselect();
  },

  _removeModelsByMake: function(unselectedMake, modelSelect) {
    const modelsToDelete = [];

    const optionsWithValue = Array.from(modelSelect.element.options).filter(option => option.value);

    optionsWithValue.forEach(function(option) {
      if (option.dataset.make === unselectedMake) {
        modelsToDelete.push(option.value);
      }
    });

    this._removeSearchFilters(modelSelect.selectDetails.name, modelsToDelete);
    modelSelect.removeOptions(modelsToDelete, false);

    if (optionsWithValue.length === modelsToDelete.length) {
      modelSelect.disableMultiselect();
    }
  },

  _getModelsByMake: function (selectedMake, modelSelect) {

    const url = new URL( window.location.origin + '/stage-ajax/getModelsByMake');

    url.searchParams.append('make', selectedMake);
    url.searchParams.append('stage-language', this._language);
    if(this._searchFilters.uuid) {
      url.searchParams.append('uuid', this._searchFilters.uuid);
    }

    // Asynchronous function call don't work here. For some reason this scope is lost if function is made asynchronous.
    // So just lets just old school promise syntax here.
    fetch(url).then(response => response.json()).then(data => {
      const formattedModels = data.models.filter(model => (
        !this._searchFilters.preset_model ||
        this._searchFilters.preset_model.includes(model.submodel.toLowerCase())
      )).map(model => {
        return {
          value: model.submodel,
          shownValue: model.submodel,
          selected: false,
          datasets: [
            {
              datasetName: 'make',
              datasetValue: model.make.toLowerCase()
            }
          ]
        }
      });

      modelSelect.addOptions(formattedModels.sort((a, b) => a.value > b.value ? 1 : -1));
      modelSelect.enableMultiselect();
    });
  },

  _updateLinkHref: function() {
    const button = document.querySelector('.move-to-car-search a');
    const form = document.getElementById('campaign-cars-search-form');
    const baseUrl = window.location.origin;
    const includeSearch = ['location', 'fueltype', 'price_min', 'price_max', 'order'];//this is typical parameeters like ?somethin&somthing
    const specialSearch = ['category','make', 'model'];//this are lnk/parameter/parameter
    //build search object
    // Clean up function
    const formFilter = ([key, val]) => (includeSearch.includes(key) && val) //get regulars parameters filter
    const specialFilter =  ([key, val]) => (specialSearch.includes(key) && val) //get specieal filter
    // Form as entries array
    const formData = Array.from(new FormData(form).entries());


    // Filter entries with function
    const filtered = formData.filter(formFilter);

    //need to add [] if multple item has same key
    const filettedArray = filtered.map(item => {
      const isMultiple = filtered.filter(element => element[0] === item[0] || element[0] === `${item[0]}[]`);
      if(isMultiple.length > 1) item[0] = `${item[0]}[]`
      return item;
    });


    //same paramters like catogory/make/model need special placement
    const specialFilterArray = [];
    const specialFiltered = formData.filter(specialFilter); //get those
    const category = specialFiltered.filter(element => element[0] === specialSearch[0]).map(item => item[1]).join(','); //check is catagory picked
    const make = specialFiltered.filter(element => element[0] === specialSearch[1]).map(item => form.querySelector(`option[value='${item[1]}']`).innerText.replace('ë', 'e')).join(','); //make value is bmw we need BMW or volvo vs Volvo
    const model = specialFiltered.filter(element => element[0] === specialSearch[2]).map(item => item[1]).join(',');

    specialFilterArray[0] = category ? category : 'kaikki';
    if(make) {
      specialFilterArray[1] = make

      if(model)
        specialFilterArray[2] = model
    }

    const searchObject = new URLSearchParams(filettedArray).toString() // Tadaa!

    // 2 luodaan url
    const url = new URL(`${button.dataset.url}${specialFilterArray.join('/')}`, baseUrl);

    // 3 sijoitetaan hakuparametriobjekti urliin
    url.search = searchObject

    // 4 url valmis!
    button.href = url.toString()
  },
};

export default campaignCarSearch;
